export const generateOrderId = () => {
  const random = Math.floor(1000000 + Math.random() * 9000000).toString();
  return `PO-${random}`;
};

export const getServiceTypes = (t: any) => [
  { value: 'body_damage', label: t('orders.serviceTypes.body_damage', { defaultValue: 'Body Damage' }) },
  { value: 'maintenance', label: t('orders.serviceTypes.maintenance', { defaultValue: 'Maintenance' }) },
  { value: 'mechanical', label: t('orders.serviceTypes.mechanical', { defaultValue: 'Mechanical' }) },
  { value: 'internal', label: t('orders.serviceTypes.internal', { defaultValue: 'Internal' }) },
];
